import SchedulingConfigurations from './SchedulingConfigurations';

export default SchedulingConfigurations;